export default "__VITE_ASSET__Brx32Rwg__"